import React from 'react'
import { Button as AntdButton } from 'antd'

import { Icon } from '@app/components/util'

import { ICON_NAME } from '@app/constants/icon'
import { SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { CSSProperties } from 'react'
import type { ButtonProps as AntdButtonProps } from 'antd'
import type { CollapseButtonProps } from './types'

const buttonCommonProps: AntdButtonProps = {
  shape: 'circle',
  size: SIZE.small
}

export const CollapseButton: React.FC<CollapseButtonProps> = ({ isCollapse, position, onClick }) => {
  const icon: JSX.Element = isCollapse ? <Icon name={ ICON_NAME.sidebarOpen } /> : <Icon name={ ICON_NAME.sidebarClose } />

  const style: CSSProperties | undefined = position
    ? {
        position: 'absolute',
        ...position
      }
    : undefined

  return (
    <AntdButton
      { ...buttonCommonProps }
      className={ styles.sideMenuButton }
      style={ style }
      onClick={ onClick }
    >
      { icon }
    </AntdButton>
  )
}
